import styled from '@emotion/styled';
import React from 'react';
import { mergeProps, useFocusRing } from 'react-aria';

import { StaticFlowCard } from '../flow-card/StaticFlowCard';

import { su } from '../../../theme/functions/su';
import { motion } from '../../../theme/motion';

import { useOptionContext } from '../../../components/list-box/ListBox';

export function ColumnItemCard(props) {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars, no-unused-vars -- intentionally unused
  const { ref, option, state, item, value } = useOptionContext();
  const focusRing = useFocusRing();

  return (
    <ColumnItemCard.Root
      {...mergeProps(option.optionProps, focusRing.focusProps)}
      ref={ref}
      className={props.className}
      style={props.style}
      as={props.as}
      data-is-selected={option.isSelected}
      data-is-focused={option.isFocused}
      data-is-focus-visible={focusRing.isFocusVisible}
      data-is-pressed={option.isPressed}
      data-is-disabled={option.isDisabled}
    >
      <StaticFlowCard
        card={value.context.card}
        droptoken={value.context.droptoken}
        cardWidth="100%"
        isFocused={option.isFocused}
        isFocusVisible={focusRing.isFocusVisible}
      />
    </ColumnItemCard.Root>
  );
}

ColumnItemCard.Root = styled.li`
  outline: 0;
  transition: transform ${motion.duration.fast} ${motion.curve.fast_in};

  &:not(:last-of-type) {
    padding-bottom: ${su(1)};
  }

  &[data-is-pressed='true'] {
    transform: scale(0.97);
  }
`;
